import {observer} from 'mobx-react';
import {BrowserRouter as Router, Route, Link} from 'react-router-dom';
import Wrapper from './components/Wrapper';
import Navbar from './components/Navbar';
import Cursor from './components/Cursor';
import Cover from './pages/Cover';
import Texts from './pages/Texts';
import Events from './pages/Events';
import Info from './pages/Info';
import UI from './stores/UI';

const NextPage = observer(() => {

  const nextRoute = (UI.routes.length - UI.page - 1) > 0 ? UI.routes[UI.page + 1] : false;

  return nextRoute ? (
    <Link to={nextRoute} className="next-page rarr"></Link>
  ) : null
})

const PrevPage = observer(() => {

  const prevRoute = UI.routes[UI.page - 1];

  return prevRoute ? (
    <Link to={prevRoute} className="prev-page larr"></Link>
  ) : null
})

const Homepage = ({match}) => (
  <div className="wrap">
    <PrevPage />
    <Cover />
    <Info />
    <Texts match={match} />
    <Events match={match} />
    <NextPage />
  </div>
)

const App = () => (
  <Router>
    <Wrapper>
      <Navbar />
      <Route component={Homepage} />
      <Route path="/texts/:slug" component={Homepage} />
      <Route path="/events/:slug" component={Homepage} />
    </Wrapper>
  </Router>
)

document.addEventListener("DOMContentLoaded", function() {
  ReactDOM.render(<App />, document.querySelector("[data-app]"));
});



// WEBPACK FOOTER //
// ./app/javascript/packs/application.js